import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AppIconComponent } from '../../../common/components/icon/icon.component';
import { MsalService } from '@azure/msal-angular';
import { RedirectRequest } from '@azure/msal-browser';
import { AuthService } from '../../../features/auth/services/auth.service';
import { environment } from '../../../../environments/environment';
import { NgOptimizedImage } from '@angular/common';

@Component({
  selector: 'app-header-home',
  imports: [AppIconComponent, NgOptimizedImage],
  templateUrl: './header-home.component.html',
  styleUrl: './header-home.component.css'
})
export class HeaderHomeComponent {
  readonly logoUrl = 'assets/img/colonial-vital-la-colonial-sm.png';
  readonly logoUrlColonial = 'assets/img/logo-la_colonialR.png';
  private auth = inject(AuthService);
  private msalService = inject(MsalService);
  private router = inject(Router);

  // true if there is a logged in user, otherwise false
  get authRetails(): boolean {
    return !!this.auth.authToken;
  }

  get userFullName(): string {
    const u: any = (this.auth as any).user;
    return (
      u?.idTokenClaims?.given_name ||
      u?.name ||
      u?.username ||
      ''
    );
  }

  /**
   * B2C sign-in here in the client app. Only retailers and managers keep the
   * session; anyone else is told to use the backoffice and signed out.
   */
  login(): void {
    const loginRequest: RedirectRequest = {
      authority: environment.b2cPolicies.authorities.signUpSignIn.authority,
      scopes: environment.apiConfig.scopes,
      redirectUri: '/',
    };
    this.msalService.loginRedirect(loginRequest);
  }

  /**
   * One registration flow for every role: the backoffice register page, where
   * the applicant picks who they are.
   */
  register(): void {
    window.location.href = `${environment.backofficeUrl}/auth/register`;
  }

  /**
   * Logout the current user
   */
  logout(): void {
    this.auth.logOut();
  }
}

